import React from 'react'
import PropTypes from 'prop-types'

class CreatedCol extends React.PureComponent {

    render() {
        const {created, productStatus} = this.props

        const timeText = created ? new Date(created).toLocaleString('en-GB') : '';

        return (
            <div className={productStatus === 'cancelled' ? 'notDisableCancel Created' : 'Created'}>
                {timeText}
            </div>
        )
    }
}

CreatedCol.propTypes = {
    productStatus: PropTypes.string,
    created: PropTypes.string,
}

export default CreatedCol
